export const generateCircleWithLetter = (letter, color='#87CEEB') => {
  const svgString = `
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
      <rect width="100%" height="100%" fill="${color}"/>
      <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#FFFFFF" font-size="36px">
        ${letter}
      </text>
    </svg>
  `;
  return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svgString)))}`;
}

export const debounce = function(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export const throttle = function (func, wait) {
  let timeout = null;
  let lastCall = 0;

  return function(...args) {
    const now = new Date().getTime();
    const remaining = wait - (now - lastCall);

    const context = this;

    const later = () => {
        lastCall = new Date().getTime();
        timeout = null;
        const result = func.apply(context, args);
        if (result instanceof Promise) {
            result.catch(err => console.error(err));
        }
    };

    if (remaining <= 0) {
        clearTimeout(timeout);
        later();
    } else if (!timeout) {
        timeout = setTimeout(later, remaining);
    }
  };
}

export const getIPhoneBottomBarHeight = function() {
  if (window.visualViewport) {
    const bottomBarHeight = window.visualViewport.height - window.innerHeight;
    return bottomBarHeight > 0 ? bottomBarHeight : 0;
  }
  return 0;
}

export const urlToBlobWithMimeType = async function (url) {
  try {
    // Fetch the image from the URL
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    // Convert the response to a Blob
    const blob = await response.blob();

    // Get the MIME type from the response headers or blob
    const mimeType = response.headers.get('Content-Type') || blob.type;
    
    return { blob, mimeType };
  } catch (error) {
    console.error('Error fetching the image:', error);
    throw error;
  }
}

export const getFileDimensions = async (file) => {
  return new Promise((resolve, reject) => {
    const fileType = file.type.split('/')[0];
    if (fileType === 'image') {
      const img = new Image();
      img.onload = function() {
        resolve({ width: img.width, height: img.height, type: 'image' });
      };
      img.onerror = function() {
          reject(new Error('Failed to load image'));
      };
      img.src = URL.createObjectURL(file);
    } else if (fileType === 'video') {
      const video = document.createElement('video');
      video.onloadedmetadata = function() {
        resolve({ width: video.videoWidth, height: video.videoHeight, type: 'video' });
      };
      video.onerror = function() {
        reject(new Error('Failed to load video'));
      };
      video.src = URL.createObjectURL(file);
    } else {
      reject(new Error('Unsupported file type'));
    }
  });
}

 export const getBlobDimensions = async function (blob) {
  return new Promise((resolve, reject) => {
      const fileType = blob.type.split('/')[0];

      if (fileType === 'image') {
          const img = new Image();
          img.onload = function() {
              resolve({ width: img.width, height: img.height, type: 'image' });
              URL.revokeObjectURL(img.src); // 释放内存
          };
          img.onerror = function() {
              reject(new Error('Failed to load image'));
          };
          img.src = URL.createObjectURL(blob);
      } else if (fileType === 'video') {
          const video = document.createElement('video');
          video.onloadedmetadata = function() {
              resolve({ width: video.videoWidth, height: video.videoHeight, type: 'video' });
              URL.revokeObjectURL(video.src); // 释放内存
          };
          video.onerror = function() {
              reject(new Error('Failed to load video'));
          };
          video.src = URL.createObjectURL(blob);
      } else {
          reject(new Error('Unsupported blob type'));
      }
  });
}

 export const compareVersions = function(version1, version2) {
  // 分割版本号字符串为数组
  const v1Parts = version1.split('.').map(Number);
  const v2Parts = version2.split('.').map(Number);

  // 获取最长版本号的长度
  const maxLength = Math.max(v1Parts.length, v2Parts.length);

  // 循环比较每个部分
  for (let i = 0; i < maxLength; i++) {
      const v1Part = v1Parts[i] || 0; // 如果版本号部分不存在，则视为0
      const v2Part = v2Parts[i] || 0;

      if (v1Part > v2Part) {
          return 1;
      }
      if (v1Part < v2Part) {
          return -1;
      }
  }

  // 所有部分都相等，版本号相等
  return 0;
}

export const isIOS = function() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}

export function stringToBase64(str) {
  const utf8Bytes = new TextEncoder().encode(str);
  const base64String = btoa(String.fromCharCode(...utf8Bytes));
  return base64String;
}
